import { createFileRoute } from '@tanstack/react-router'
import Whatsapp from '@/components/settings-route/multi-channel/whatsapp'

export const Route = createFileRoute('/_auth/settings/multi-channels/whatsapp')(
  {
    component: Whatsapp,
  },
)
